import React, { useState } from "react";
import { Divider, makeStyles, Typography } from "@material-ui/core";
import pinLocation from "../../../assets/images/pin-location.svg";
import { getDynamicIconSize } from "../../liveBusLocations/tools";

interface IMarker {
  lat: number;
  lng: number;
  key: string;
  zoom: number;
  record: ISchool;
}

const SchoolMarker = ({ record, zoom }: IMarker) => {
  const [isOpenInfoWindow, setIsOpenInfoWindow] = useState<boolean>(false);

  const iconSize = getDynamicIconSize(zoom);

  return (
    <div
      style={{
        position: "absolute",
        transform: "translate(-50%, -90%)",
        cursor: "pointer",
        zIndex: 12,
      }}
      onClick={() => setIsOpenInfoWindow((value) => !value)}
    >
      <img
        src={pinLocation}
        alt="School Marker"
        style={{
          width: `${iconSize}px`, // Dynamic size based on zoom level
          height: `${iconSize}px`, // Dynamic size based on zoom level
        }}
      />

      {isOpenInfoWindow && <InfoWindow record={record} />}
    </div>
  );
};

interface IInfoWindow {
  record: ISchool;
}

const InfoWindow = ({ record }: IInfoWindow) => {
  const useStyles = makeStyles({
    infoWindowWrapper: {
      position: "absolute",
      left: "100%",
      transform: "translateX(10%)",
      width: 220,
      backgroundColor: "white",
      color: "black",
      padding: 10,
      fontSize: 14,
      zIndex: 100,
    },
  });

  const classes = useStyles();

  return (
    <div className={classes.infoWindowWrapper}>
      <Typography variant="subtitle2" gutterBottom>
        {record.name}
      </Typography>

      <Divider style={{ margin: "10px 0px" }} />

      <Typography variant="body2" gutterBottom>
        {record.address}
      </Typography>
    </div>
  );
};

export default SchoolMarker;
